import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import Seo from '@components/Seo'
import { useStore } from '@Store/'
import { setHeaderColor, showDisplayControls, setShowHeaderBackground } from '@Store/'
import { colors } from '@styles/vars/colors.style'
import Intro from '@components/_OurWorks/Intro'
import CaseStudies from '@components/_OurWorks/CaseStudies'
import PageFooter from '@components/_OurWorks/PageFooter'

const OurWorksPage = ({ data, location }) => {
  const [, dispatch] = useStore()
  const { seo, slug, introText, footer } = data.contentfulOurWorks
  const caseStudies = data.allContentfulCaseStudy.nodes

  useEffect(() => {
    setHeaderColor(dispatch, colors.white, colors.charcoal)
    showDisplayControls(dispatch, true)
    setShowHeaderBackground(dispatch, true)
  }, [dispatch, location])

  return (
    <>
      <Seo data={seo} slug={slug} />

      <Intro title={introText} />

      <CaseStudies caseStudies={caseStudies}/>

      <PageFooter content={footer} />
    </>
  )
}

export default OurWorksPage

export const pageQuery = graphql`
  query OurWorksPage($slug: String!) {
    contentfulOurWorks(slug: { eq: $slug }) {
      seo {
        ...SEO
      }
      title
      slug
      introText {
        raw
      }
      footer {
        ...PageFooter
      }
    }
    allContentfulCaseStudy(sort: { fields: [order, createdAt], order: [DESC, DESC] }) {
      nodes {
        slug
        metadata {
          tags {
            name
          }
        }
        mainImage {
          ...Image
        }
        secondaryImage {
          ...Image
        }
        heroText {
          raw
        }
        title
        content {
          ... on ContentfulCaseStudyService {
            __typename
            services
          }
        }
      }
    }
  }
`
